// extracted by mini-css-extract-plugin
module.exports = {"form-container":"b1ddd01198--form-container--jx8F3","title-container":"b1ddd01198--title-container--Ll3sj"};